import { render, staticRenderFns } from "./OurIconButton.vue?vue&type=template&id=6ee510fe&"
import script from "./OurIconButton.vue?vue&type=script&lang=js&"
export * from "./OurIconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports